import { ApiService, ElementsService } from 'dbweb-core';
import { Injectable } from '@angular/core';
const eleSetDept = 'setdept';
@Injectable({
	providedIn: 'root'
})
export class SetDeptService {
	constructor(private api: ApiService, private eles: ElementsService) {}
	codeExists(code: string) {
		return this.api.get<Boolean>(
			this.eles.get(eleSetDept).URL,
			'code-exists',
			this.eles.get(eleSetDept).SignStr,
			code
		);
	}
}
